import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { H2 } from 'foundations-components/transitional/components/H2';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { ModalPanel } from 'foundations-components/transitional/components/ModalPanel';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Component } from 'react';
import UsersAndTeamsSelector from './UsersAndTeamsSelector';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class UsersAndTeamsAssetAccessPanel extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      selectedUserIds: [],
      selectedTeamIds: []
    };
    this.handleSave = () => {
      const {
        selectedTeamIds,
        selectedUserIds
      } = this.state;
      this.props.onSave({
        selectedTeamIds,
        selectedUserIds
      });
    };
  }
  renderSave() {
    const {
      selectedTeamIds,
      selectedUserIds
    } = this.state;
    const {
      allowPrivate,
      showSaveLoading
    } = this.props;
    const hasUsersButNoTeams = selectedTeamIds.length === 0 && selectedUserIds.length > 0;
    const button = /*#__PURE__*/_jsx(LoadingButton, {
      "data-test-id": "confirm-button",
      use: "primary",
      onClick: this.handleSave,
      loading: showSaveLoading,
      disabled: hasUsersButNoTeams && !allowPrivate,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ui-asset-management-lib.assetAccessPanel.buttonLabels.save"
      })
    });
    if (hasUsersButNoTeams && !allowPrivate) {
      return /*#__PURE__*/_jsx(Tooltip, {
        placement: "left",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ui-asset-management-lib.tooltips.usersButNoTeamsError"
        }),
        children: button
      });
    }
    return button;
  }
  render() {
    const {
      allowPrivate,
      allowSetEditLevel,
      assetTypeDisplayName,
      userHasTeamAssignmentScope,
      assignedUserIds,
      assignedTeamIds,
      teams,
      description,
      requestsLoading,
      requestsError,
      useAccessLanguage,
      allowedUserIds,
      disallowedUserFormattedMessageKey,
      allowedTeamIds,
      disallowedTeamFormattedMessage,
      disableAccessToEveryone,
      disableAccessToEveryoneFormattedMessage,
      autoSelectAncestors
    } = this.props;
    return /*#__PURE__*/_jsxs(ModalPanel, {
      "data-test-id": "users-and-teams-asset-access-panel",
      children: [/*#__PURE__*/_jsxs(DialogHeader, {
        children: [/*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: this.props.onCancel
        }), /*#__PURE__*/_jsx(H2, {
          children: assetTypeDisplayName ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ui-asset-management-lib.assetAccessPanel.title",
            options: {
              assetType: assetTypeDisplayName
            }
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ui-asset-management-lib.assetAccessPanel.defaultTitle"
          })
        })]
      }), /*#__PURE__*/_jsxs(DialogBody, {
        children: [/*#__PURE__*/_jsx(Text, {
          marginBlockEnd: "500",
          as: "p",
          children: description
        }), /*#__PURE__*/_jsx(UsersAndTeamsSelector, {
          allowPrivate: allowPrivate,
          allowSetEditLevel: allowSetEditLevel,
          assignedUserIds: assignedUserIds,
          assignedTeamIds: assignedTeamIds,
          teams: teams,
          requestsLoading: requestsLoading,
          requestsError: requestsError,
          userHasTeamAssignmentScope: userHasTeamAssignmentScope,
          onUpdateUserIds: selectedUserIds => this.setState({
            selectedUserIds
          }),
          onUpdateTeamIds: selectedTeamIds => this.setState({
            selectedTeamIds
          }),
          fullWidth: true,
          useAccessLanguage: useAccessLanguage,
          allowedUserIds: allowedUserIds,
          disallowedUserFormattedMessageKey: disallowedUserFormattedMessageKey,
          allowedTeamIds: allowedTeamIds,
          disallowedTeamFormattedMessage: disallowedTeamFormattedMessage,
          disableAccessToEveryone: disableAccessToEveryone,
          disableAccessToEveryoneFormattedMessage: disableAccessToEveryoneFormattedMessage,
          autoSelectAncestors: autoSelectAncestors
        })]
      }), /*#__PURE__*/_jsxs(DialogFooter, {
        children: [this.renderSave(), /*#__PURE__*/_jsx(Button, {
          use: "secondary",
          onClick: this.props.onCancel,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ui-asset-management-lib.assetAccessPanel.buttonLabels.cancel"
          })
        })]
      })]
    });
  }
}
UsersAndTeamsAssetAccessPanel.defaultProps = {
  allowPrivate: false,
  allowSetEditLevel: false,
  requestsError: false,
  requestsLoading: false,
  showSaveLoading: false,
  userHasTeamAssignmentScope: true,
  useAccessLanguage: false,
  description: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "ui-asset-management-lib.description.default"
  })
};
export default UsersAndTeamsAssetAccessPanel;